<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
  <g>
    <rect class="cls-3" x="8.48" y="34.77" width="22.23" height="31.43" rx="4.45" ry="4.45"/>
    <rect class="cls-3" x="33.92" y="24.12" width="22.23" height="42.08" rx="4.45" ry="4.45"/>
    <rect class="cls-3" x="59.37" y="13.38" width="22.23" height="52.81" rx="4.45" ry="4.45"/>
    <g>
      <path class="cls-2" d="M74,76.1H9.96c-.82,0-1.48-.67-1.48-1.5s.66-1.5,1.48-1.5H74c.82,0,1.48,.67,1.48,1.5s-.66,1.5-1.48,1.5Z"/>
      <path class="cls-2" d="M73.39,79.81l7.84-4.57c.48-.28,.48-.98,0-1.26l-7.84-4.57c-.48-.28-1.08,.07-1.08,.63v9.15c0,.56,.6,.91,1.08,.63Z"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
    name: "VolumeTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #cfeae0;
  }
</style>